import styled from "styled-components";

export const CommentItem = styled.div`
  &.comments {
    padding-top: 17px;

    & .more {
      width: 44px;
      height: 44px;
      margin-right: -10px;

      cursor: pointer;
    }
  }
`;

// export const InputComments = styled.div`
//   width: calc(100% - 32px);
//   padding-left: 12px;
//   padding-right: 12px;
//   margin-top: 11px;
//   margin-bottom: 12px;
//   background: #f1f3f5;
//   border-radius: 8px;
//   box-sizing: border-box;

//   & textarea {
//     width: 100%;
//     border: none;
//     outline: none;
//     resize: none;
//     overflow: hidden;

//     font-size: 14px;

//     background: #f1f3f5;
//     box-sizing: border-box;

//     &::placeholder {
//       font-size: 14px;
//       letter-spacing: -0.02em;
//       color: #4a5056;
//     }

//     &.blur {
//       margin-top: 12px;
//       margin-bottom: 8px;
//     }

//     &.focus {
//       margin-top: 12px;
//       margin-bottom: 8px;
//       color: #4a5056;
//       caret-color: #ff7a00;

//       &::placeholder {
//         color: #878e95;
//       }
//     }
//   }

//   & .textareaAside {
//     display: flex;
//     justify-content: space-between;
//     padding-bottom: 8px;
//     margin-top: 14px;
//     color: #4a5056;
//     box-sizing: border-box;

//     & div {
//       font-size: 12px;
//     }

//     & button {
//       border: none;
//       outline: none;
//       font-size: 14px;
//       line-height: 20px;
//       cursor: pointer;

//       &.orange {
//         color: #ff7a00;
//         font-weight: 700;
//       }

//       &.black {
//         color: #000;
//         font-weight: 400;
//       }
//     }
//   }
// `;
